import React from 'react'

import NavBar from '../components/NavBar'
import Footer from '../components/Footer'

function Template({ location, children } = {}) {
  const { pathname } = location

  return (
    <div className="w-100">
      <NavBar linkable={pathname !== '/'} />
      {children()}
      <Footer />
    </div>
  )
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.jsx